import { Link } from "react-router-dom";
import { Instagram, Facebook, Phone, Mail, MapPin } from "lucide-react";
import { CAFE_INFO, WHATSAPP_RESERVE_URL } from "../data/cafe";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/10 bg-[#050505] mt-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-6">
            <img
              src={CAFE_INFO.logo}
              alt="mismos"
              className="h-14 w-14 rounded-full ring-1 ring-white/10"
            />
            <div>
              <div className="font-display text-2xl">mismos</div>
              <div className="text-xs uppercase tracking-[0.3em] text-white/50">
                Your Daily Dose of Chill
              </div>
            </div>
          </div>
          <p className="text-white/60 max-w-md leading-relaxed">
            A neighborhood retreat for slow afternoons, late-night cravings
            and the kind of drinks worth lingering over.
          </p>
          <div className="flex gap-3 mt-6">
            <a
              data-testid="footer-social-instagram"
              href={CAFE_INFO.social.instagram}
              target="_blank"
              rel="noreferrer"
              className="h-10 w-10 grid place-items-center rounded-full border border-white/15 hover:border-[#FF8C5A] hover:text-[#FF8C5A] transition"
            >
              <Instagram size={16} />
            </a>
            <a
              data-testid="footer-social-facebook"
              href={CAFE_INFO.social.facebook}
              target="_blank"
              rel="noreferrer"
              className="h-10 w-10 grid place-items-center rounded-full border border-white/15 hover:border-[#FF8C5A] hover:text-[#FF8C5A] transition"
            >
              <Facebook size={16} />
            </a>
          </div>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.3em] text-white/50 mb-5">
            Visit
          </h4>
          <ul className="space-y-3 text-white/80 text-sm">
            <li className="flex gap-3" data-testid="footer-address">
              <MapPin size={16} className="mt-0.5 text-[#FF8C5A]" />
              {CAFE_INFO.address}
            </li>
            <li className="flex gap-3" data-testid="footer-phone">
              <Phone size={16} className="mt-0.5 text-[#FF8C5A]" />
              {CAFE_INFO.phone}
            </li>
            <li className="flex gap-3" data-testid="footer-email">
              <Mail size={16} className="mt-0.5 text-[#FF8C5A]" />
              {CAFE_INFO.email}
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.3em] text-white/50 mb-5">
            Hours
          </h4>
          <ul className="space-y-3 text-white/80 text-sm">
            {CAFE_INFO.hours.map((h) => (
              <li key={h.day}>
                <div className="text-white">{h.day}</div>
                <div className="text-white/50">{h.time}</div>
              </li>
            ))}
          </ul>
          <a
            href={WHATSAPP_RESERVE_URL}
            target="_blank"
            rel="noreferrer"
            data-testid="footer-reserve-link"
            className="inline-block mt-6 text-sm text-gradient font-medium"
          >
            Reserve a table →
          </a>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/40">
          <div>© {new Date().getFullYear()} mismos. All rights reserved.</div>
          <div>Crafted slowly. Served chilled.</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
